import { configuredIntegrationsResource } from '../configured-integrations/resources';
import { integrationListResource } from '../integration-list/resources';
import { userAccessRightsResource } from '../user-access-rights/resources';
export const resources = {
  configuredIntegrationsResource,
  integrationListResource,
  userAccessRightsResource
};